import type { ReactNode } from "react";
import { cn } from "../../lib/utils";

type RegularPageLayoutProps = {
  children: ReactNode;
  className?: string;
  width?: "3xl" | "6xl";
  paddingY?: "6" | "8";
};

export function RegularPageLayout({
  children,
  className,
  width = "6xl",
  paddingY = "6",
}: RegularPageLayoutProps) {
  const widthClass = width === "3xl" ? "max-w-3xl" : "max-w-6xl";
  const paddingYClass = paddingY === "8" ? "py-8" : "py-6";

  return (
    <main
      className={cn(
        "mx-auto flex flex-col gap-6 px-6",
        widthClass,
        paddingYClass,
        className
      )}
    >
      {children}
    </main>
  );
}

type AuthPageLayoutProps = {
  children: ReactNode;
  className?: string;
};

export function AuthPageLayout({ children, className }: AuthPageLayoutProps) {
  return <main className={cn("mx-auto max-w-lg px-6 py-10", className)}>{children}</main>;
}
